import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const TABLE_ROW_COUNT = 100;

export const isProgressiveWebApp = window.matchMedia(
  "(display-mode: standalone)"
).matches;

const formatNumberWithDecimal = (
  number: string | number,
  digit?: number,
  toInteger?: boolean
) => {
  if (toInteger) return Number(number)?.toFixed(0);
  const isDecimal = Number(number) % 1 !== 0;
  const num = isDecimal ? Number(number)?.toFixed(digit || 2) : number;
  return num;
};

export const formatWithPercentage = (
  number: string | number,
  digit?: number,
  toInteger?: boolean
) => {
  const num = formatNumberWithDecimal(number, digit, toInteger);
  return `${num.toString()}%`;
};

export const formatNumberWithCommaAndDollar = (
  number: string | number,
  digit?: number,
  toInteger?: boolean
) => {
  const num = formatNumberWithDecimal(number, digit, toInteger);
  return `$${num
    .toString()
    .replace(/[^\d.-]/g, "")
    .replace(/(\d)-/g, "$1")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const formatNumberWithComma = (
  number: string | number,
  digit?: number,
  toInteger?: boolean
) => {
  const num = formatNumberWithDecimal(number, digit, toInteger);
  return num
    .toString()
    .replace(/[^\d.-]/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatTimeUtctoEst = (time: string) => {
  return dayjs(time)?.tz("America/New_York")?.format("h:mm A");
};

export const ErrorState = () => {
  return <>-</>;
  // it could be used in future
  // <EmptyState>
  //   <AlertTriangle color={Colors.primaryred} />
  //   {/* <EmptyStateText>N/A</EmptyStateText> */}
  // </EmptyState>
};

ErrorState.defaultProps = {
  isDataTable: false,
};

export const ZIndex = {
  LEVEL_1: 9999,
  LEVEL_2: 999,
  LEVEL_3: 99,
  LEVEL_4: 9,
  LEVEL_5: -1,
};

export const message = {
  CONFIRMATION_TITLE_NOTE_EMAIL: "Sending notes",
  CONFIRMATION_MESSAGE_NOTE_EMAIL:
    "This action will send out an email with the notes to the users that can view this location. Proceed?",
  SUCCESS_MESSAGE_NOTE_CREATE:
    "Note created successfully, please add the content",
  SUCCESS_MESSAGE_NOTE_UPDATE: "Note content updated successfully",
  SUCCESS_MESSAGE_NOTE_EMAIL: "Notes sent via email",
  ERROR_MESSAGE: "Something went wrong!",
  ERROR_MESSAGE_DASHBOARD: "Unable to Fetch Dashboard Content",
  ERROR_MESSAGE_NOTE: "Unable to Fetch Notes Content",
  ERROR_MESSAGE_NOTE_CREATE: "Unable to Create Note",
  ERROR_MESSAGE_NOTE_EMAIL: "Unable to Send Notes via email",
  ERROR_MESSAGE_EventTypes: "Unable to Fetch Event Types Content",
  ERROR_MESSAGE_UNAUTHORIZED: "Unauthorized",
  ERROR_MESSAGE_SESSION_EXPIRED:
    "Authentication Failed. Your session token has expired please sign in again.",
};

export const DEFAULTSALESVALUE = [4];

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const localTableFilters = [
  "RevenueFilter",
  "LabourShiftFilter",
  "LabourFilter",
  "CogsFilter",
  "notification",
];

export const blacklist = [
  "labour-dashboard",
  "cogs-dashboard",
  "revenue-dashboard",
  "notification-center",
];

export const HistoricalReportRoute = "/historical-reports";

export const ConditionalRoutes = {
  LabourDashboard: "labour-dashboard",
  CogsDashboard: "cogs-dashboard",
};

export const PropertyValues = {
  RestaurantsCatering: "002",
  Pinnacle: "005",
};

export const numberFormatter = (value: number) => {
  return new Intl.NumberFormat("en", {
    notation: "compact",
  }).format(value);
};

export const DEFAULT_MIN_DATE = "2022-07-01";
